import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { statusColor, chooseStatusOnGoing } from 'utils/common';
import cn from 'classnames';

import OngoingMarker from '../OngoingMarker/OngoingMarker';

import { getComponentId } from './helpers/helpers';

import { useContent } from 'contexts/content-context';

import classes from './ActualStatusMarker.module.scss';

const ActualStatusMarker = ({
  networkId,
  networkComponent,
  componentType,
  showStatusText
}) => {
  const [netComponent, setNetComponent] = useState(networkComponent);

  const { contentState } = useContent();

  useEffect(() => {
    async function getActualStatus() {
      const id = await getComponentId(networkId, netComponent, componentType);
      const componentStatus = contentState.actualStatus.find(
        itemStatus => itemStatus.id == id
      );

      if (componentStatus) {
        const newNetworkComponent = {
          ...netComponent,
          actualStatus: componentStatus.status
        };

        setNetComponent(newNetworkComponent);
      }
    }
    getActualStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkComponent, contentState]);

  return (
    <>
      {netComponent && (
        <>
          {netComponent.actualStatus === undefined ? (
            <div
              className={cn(
                classes.networkStatusMarker,
                showStatusText && classes.withStatusTextStyle
              )}
              style={{
                backgroundColor: statusColor(netComponent.actualStatus)
              }}
            >
              <span className={!showStatusText && classes.visually_hidden}>
                {'NA'}
              </span>
            </div>
          ) : netComponent.actualStatus === 'inactive' ? (
            <div
              className={cn(
                classes.networkStatusMarker,
                showStatusText && classes.withStatusTextStyle
              )}
              style={{
                backgroundColor: statusColor(netComponent.actualStatus)
              }}
            >
              <span className={!showStatusText && classes.visually_hidden}>
                {netComponent.actualStatus}
              </span>
            </div>
          ) : netComponent.isOnGoingAlertExist ? (
            <div className={classes.marker}>
              <OngoingMarker
                status={chooseStatusOnGoing(netComponent.isOnGoingAlertExist)}
              />
            </div>
          ) : (
            <div
              className={cn(
                classes.networkStatusMarker,
                showStatusText && classes.withStatusTextStyle
              )}
              style={{
                backgroundColor: statusColor(netComponent.actualStatus)
              }}
            >
              <span className={!showStatusText && classes.visually_hidden}>
                {netComponent.actualStatus}
              </span>
            </div>
          )}{' '}
        </>
      )}
    </>
  );
};

ActualStatusMarker.propTypes = {
  networkId: PropTypes.string,
  networkComponent: PropTypes.object,
  componentType: PropTypes.string,
  showStatusText: PropTypes.bool
};

export default ActualStatusMarker;
